// @flow
import path from 'ramda/es/path';
import omit from 'ramda/es/omit';
import prop from 'ramda/es/prop';

import shopApiRequest from 'app/actions/shopApi';
import action from 'app/common/lib/action';


export const SHOP_CATEGORIES_REQUEST = 'SHOP_CATEGORIES_REQUEST';
export const SHOP_CATEGORIES_SUCCESS = 'SHOP_CATEGORIES_SUCCESS';
export const SHOP_CATEGORIES_FAILURE = 'SHOP_CATEGORIES_FAILURE';
export const SHOP_CATEGORIES_CLEAR = 'SHOP_CATEGORIES_CLEAR';

const removeChildren = (a: ?Object) => {
  if (a) {
    return omit(['children'], a);
  }
  return {};
};

const getChildren = (a: ?Object) => {
  if (a) {
    return prop('children', a);
  }
  return [];
};

/**
 * Запрос категорий каталога
 */
export const сategoriesFetch = (slug: ?string) => async (dispatch: Function) => {
  const apiPath = slug ? `categories/${slug}` : 'categories';
  dispatch(action(SHOP_CATEGORIES_REQUEST, slug));
  try {
    const res = await shopApiRequest(apiPath, 'get');
    const data = path(['data', 'data'], res);
    const isRoot = data instanceof Array;
    const current = (isRoot ? {} : removeChildren(data));
    const children = (isRoot ? data : getChildren(data));
    dispatch(action(SHOP_CATEGORIES_SUCCESS, { current, children }));
    return { errStatus: 0 };
  } catch (error) {
    const status = path(['response', 'status'], error);
    dispatch(action(SHOP_CATEGORIES_FAILURE, {
      err: 'Запрос категорий каталога не удался',
      slug,
      error,
    }));
    return { errStatus: status };
  }
};
